module.exports = __webpack_public_path__ + "img/home-z-one.a0e8fbba.jpg";